import { IconsProps } from '@/types/shared'
import React from 'react'

const CheckCircleOutlinedIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.1 15.35L16.15 8.3L14.75 6.9L9.1 12.55L6.25 9.7L4.85 11.1L9.1 15.35ZM10.5 20.75C9.11667 20.75 7.81667 20.4875 6.6 19.9625C5.38333 19.4375 4.325 18.725 3.425 17.825C2.525 16.925 1.8125 15.8667 1.2875 14.65C0.7625 13.4333 0.5 12.1333 0.5 10.75C0.5 9.36667 0.7625 8.06667 1.2875 6.85C1.8125 5.63333 2.525 4.575 3.425 3.675C4.325 2.775 5.38333 2.0625 6.6 1.5375C7.81667 1.0125 9.11667 0.75 10.5 0.75C11.8833 0.75 13.1833 1.0125 14.4 1.5375C15.6167 2.0625 16.675 2.775 17.575 3.675C18.475 4.575 19.1875 5.63333 19.7125 6.85C20.2375 8.06667 20.5 9.36667 20.5 10.75C20.5 12.1333 20.2375 13.4333 19.7125 14.65C19.1875 15.8667 18.475 16.925 17.575 17.825C16.675 18.725 15.6167 19.4375 14.4 19.9625C13.1833 20.4875 11.8833 20.75 10.5 20.75ZM10.5 18.75C12.7333 18.75 14.625 17.975 16.175 16.425C17.725 14.875 18.5 12.9833 18.5 10.75C18.5 8.51667 17.725 6.625 16.175 5.075C14.625 3.525 12.7333 2.75 10.5 2.75C8.26667 2.75 6.375 3.525 4.825 5.075C3.275 6.625 2.5 8.51667 2.5 10.75C2.5 12.9833 3.275 14.875 4.825 16.425C6.375 17.975 8.26667 18.75 10.5 18.75Z"
                    fill="#008556"
                />
            </svg>
        </div>
    )
}

export default CheckCircleOutlinedIcons
